export const initialState = () => ({
  loading: {
    show: false,
    message: ""
  },
  isEditing: false,
  isEditingOfflineSale: false,
  isTransformingOfflineSale: false,
  origin: "",
  rules: {
    shouldBypassCoverage: false
  },
  summaryNote: "",
  alreadySaved: false,
  saleToEditId: "",
  saleToTransformId: "",
  offlineSales: [],
  isSyncingOfflineSales: false,
  saleCode: "",
  alreadySynced: false,
  showRGfield: true,
})
